module.exports = __webpack_public_path__ + "static/neon-yellow-left-986a9883327f81497f53c94b369c76f9.jpg";